$(function () {
	if (typeof initFBLogin !== "undefined") initFBLogin();
	if (typeof initGoogleLogin !== "undefined") initGoogleLogin();

	$('#mainContainer').on('click','#btnLogin',function(e) {
		e.preventDefault;
		var frmLogin = $(this).closest('#frmLogin');
		validateLogin(frmLogin);
		return false;
	});

	$('#btnLoginUserAgent').click(function() {
		var frmLogin = $('#frmLoginUser');
		validateLoginUserAgent(frmLogin);
		return false;
	});

	// Check if email address exists
	$('#btnRegister').on('click',function(){
		if($(el('inputEmailRegister')).length > 0)
		{
			if($(el('inputEmailRegister')).val() !== '')
			{
				checkLoginEmail($(el('inputEmailRegister')).val());
			}
			return false;
		}
	});

	$(el('frmRegister')).on('submit', function(event){
		event.preventDefault();

		$(el('btnRegister')).trigger('click');
	});

	// check if header contains login form (gm)
	var bHeaderLoginForm = ($('header').find('#inputPassword').length > 0)
	$(el('mainContainer')).on('keyup mouseup', '#inputPassword,#inputPasswordCheck', function()
	{
		var oParent = $(this).parents('.inputPasswordContainer');
		if(oParent.find('.toggleLoginPassword').length == 0 && $(this).val() !== "" && (!bHeaderLoginForm || (bHeaderLoginForm && $(this).closest('#frmRegister').length == 0)))
		{
			$("<span class='toggleLoginPassword'>" + sShowPasswordBtnLabel + "</span>").insertAfter($(this));
		}
		else if($('.toggleLoginPassword').length > 0 && $(this).val() == "" && (!bHeaderLoginForm || (bHeaderLoginForm && $(this).closest('#frmRegister').length == 0)))
		{
			oParent.find('.toggleLoginPassword').remove();
		}
	});

	$(el('mainContainer')).on('blur', '#inputPassword,#inputPasswordCheck', function()
	{
		$(el('inputPassword')).prop('type','password');
	});

	$(el('mainContainer')).on('click','.toggleLoginPassword', function(event)
	{
		var oEl = $(this).parents('.inputPasswordContainer').find('input');
		var switchValue = (oEl.prop('type') === 'password')?'text':'password';
		oEl.prop('type',switchValue);

		$(this).removeClass('active');
		if(switchValue == 'text')
		{
			$(this).addClass('active');
		}

		event.stopPropagation();
	});

	$(document).click(function(event)
	{
		$target = $(event.target);
		if(!$target.hasClass('toggleLoginPassword') && $target.attr('id') !== 'inputPassword')
		{
			$(el('inputPassword')).parents('.inputPasswordContainer').find('.toggleLoginPassword').remove();
			$(el('inputPassword')).prop('type','password');
		}
		if(!$target.hasClass('toggleLoginPassword') && $target.attr('id') !== 'inputPasswordCheck')
		{
			$(el('inputPasswordCheck')).parents('.inputPasswordContainer').find('.toggleLoginPassword').remove();
			$(el('inputPasswordCheck')).prop('type','password');
		}
	});

	if($('#inputPassword').parents('.inputPasswordContainer').length == 0)
	{
		var sMarginBottom = $(el('inputPassword')).css("marginBottom");
		$(el('inputPassword')).wrap('<div class="inputPasswordContainer"></div>');
		$(el('inputPassword')).css("marginBottom", '0');
		$('#inputPassword').parents('.inputPasswordContainer').css("marginBottom",sMarginBottom);
	}

	$(el('mainContainer')).on('click','.forgotPasswordHref', function(event)
	{
		event.preventDefault();

		var sHref = $(this).attr("href");
		if($(el("inputEmail")).val() !== "")
		{
			sHref += "?email=" + encodeURIComponent($(this).closest('form').find("#inputEmail").val());
		}

		window.location.href = sHref;
	});


});

function checkLoginEmail(email)
{
	uAjax = '/index.cfm/customer/ajax/checkemail';
	var sParams = '&email=' + encodeURIComponent(email) + '&forLogin=true';
	var oCall = callAjax("checkemail", sParams, "post");
	oCall.success(function(oData) {
		if (oData.errorType === '') {
			window.location = registerLink + '?email=' + encodeURIComponent(email);
		} else {
			inlineAlert('error', oData.errorMessage, oData.errorUnhandled, $(el('btnRegister')));
		}
	});
}

function validateLogin(frmLogin) {
    uAjax = "/index.cfm/customer/ajax/login";

	clearErrors();
	var bValid = validateForm(frmLogin);

	if (bValid)
	{
		if(typeof gRecaptchaSiteKey !== "undefined" && gRecaptchaSiteKey && typeof grecaptcha !== "undefined"){
			grecaptcha.ready(function() {
				grecaptcha.execute(gRecaptchaSiteKey, {action: 'login'}).then(function(token) {
					executeLogin(frmLogin,token);
				});
			});
		}
		else{
			executeLogin(frmLogin);
		}
	}
}

function executeLogin(frmLogin,token){

	$(el('btnLogin')).prop('disabled',true);

	frmLogin.find('.success').removeClass('success');

	var autoLogin = true;
	if(frmLogin.find('input[type=checkbox]').length > 0)
	{
		autoLogin = frmLogin.find('input[type=checkbox]').is(':checked');
	}

	var sParams = '&email=' + encodeURIComponent(frmLogin.find('#inputEmail').val()) + '&password=' + encodeURIComponent(frmLogin.find('#inputPassword').val()) + '&remember=' + autoLogin + '&grecaptchatoken=' + encodeURIComponent(token);
	var oCall = callAjax("login", sParams, "post");
	oCall.success(function(oData) {
		if (oData.errorType == '') {
			showAlert('warning', tLoggedIn, false);
			setTimeout(function() {
				if(typeof sPathInfoWithQueryParams !== 'undefined' && sPathInfoWithQueryParams !== '')
				{
					window.location = sPathInfoWithQueryParams;
				}
				else if(typeof sLoginRedirect !== 'undefined' && sLoginRedirect !== '')
				{
					window.location = sLoginRedirect;
				}
				else
				{
					window.location = '/' + sCurrentLanguageCode + '/transaction';
				}

			}, 2000);
		} else {
			$(el('btnLogin')).prop('disabled',false);

			if(oData.errorType === 'classification')
			{
				clearErrors();
				$('body').append(oData.html);
				$('#webshops').modal();
				centerPopups();
			}
			else if(oData.errorType === 'multiple')
			{
				clearErrors();

				$(el("contactsPopup")).remove();
				$(el("mainContainer")).append(oData.html);
				$(el("contactsPopup")).modal();

				centerPopups();
			}
			else
			{
				inlineAlert('error', oData.errorMessage, oData.errorUnhandled, frmLogin.find('#btnLogin'),false);
			}
		}
	});
}


function validateLoginUserAgent(frmLogin) {
    var uAjax = "/index.cfm/ajax/loginUser";
	clearErrors();
	var bValid = validateForm(frmLogin);
	if (bValid) {
		frmLogin.find('.success').removeClass('success');
		var sParams = '&user=' + encodeURIComponent($('#frmLoginUser').find('#inputUser').val()) + '&password=' + encodeURIComponent($('#frmLoginUser').find('#inputPassword').val());
		var oCall = callAjax("loginUser", sParams, "post", uAjax);
		oCall.success(function(oData) {
			if (oData.errorType == '') {
				showAlert('warning', tLoggedIn, false);
				setTimeout(function() {
					window.location = '/' + sCurrentLanguageCode + '/customer/search'
				}, 2000);
			} else {
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
			}
		});
	} else {}
}